// Phase 18 Plan 06 — POLISH-11 AboutFonts collapsible attribution.
//
// Adds OpenDyslexic SIL OFL 1.1 attribution to Settings → Accessibility.
// SCOWL + SALDO wordlist attributions remain on the Footer + AboutScreen
// (see apps/web/src/ui/about/Attribution.tsx + apps/web/src/ui/footer/
// Footer.tsx) — those are the wordlist attributions per DEC-020 + DEC-026.
// This component adds the third typography-license attribution introduced
// by POLISH-11 (the dyslexia-friendly font binary self-hosted under
// apps/web/public/fonts/OpenDyslexic-{Regular,Bold}.woff2 per DEC-015).
//
// Rendered as <details> + <summary> so it stays compact in the Settings
// section until the user expands it — matching UI-SPEC §Visuals "About
// fonts" collapsible callout.

import type { JSX } from 'react'
import { FormattedMessage } from 'react-intl'

export function AboutFonts(): JSX.Element {
  return (
    <details
      className="settings-about-fonts"
      data-testid="about-fonts"
      style={{
        width: '100%',
        margin: 0,
      }}
    >
      <summary
        style={{
          fontFamily: 'Fredoka, sans-serif',
          fontWeight: 700,
          fontSize: '14px',
          color: 'var(--color-text-primary)',
          cursor: 'pointer',
          padding: '4px 0',
        }}
      >
        <FormattedMessage
          id="settings.about_fonts.heading"
          defaultMessage="About fonts"
        />
      </summary>
      <p
        style={{
          margin: '8px 0 0 0',
          fontFamily: 'Manrope, system-ui, sans-serif',
          fontWeight: 500,
          fontSize: '14px',
          color: 'var(--color-text-secondary)',
          lineHeight: 1.5,
        }}
      >
        <FormattedMessage
          id="settings.about_fonts.opendyslexic_attribution"
          defaultMessage="OpenDyslexic font (SIL OFL 1.1) by Abelardo Gonzalez. Self-hosted."
        />
      </p>
    </details>
  )
}
